import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import Table from './LocationTable';
import Pagination from '../../CustomControls/Pagination';
import { getAllLocations, setOnConfirmationModal, deleteLocation } from '../../../store/actions/Master/location';
import LoadingSpinner from '../../CustomControls/Spinner';
import Notification from '../../CustomControls/Notification';
import Breadcrumbs from '../../CustomControls/Breadcrumb';
import { _create, _location, _delete } from '../../../constants/componentConstants';
import { hasPermissionToAction } from '../../../utils/accessUtil';
import SearchBar from '../../CustomControls/SearchBar';
import CustomConfirmation from '../../CustomControls/ConfirmationModal';
import './style.scss';

const Location = props => {
  const [searchText, setSearchText] = useState('');
  const [results, setResults] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useSelector(state => state.location);
  const ui = useSelector(state => state.ui);
  const permissions = ui.layout.permissions;
  const pageSize = ui.layout.pageSize;

  const notificationType = location.isError ? 'error' : 'success';

  const showSaveOption = hasPermissionToAction(permissions, _location, _create);
  const showDeleteOption = hasPermissionToAction(permissions, _location, _delete);

  useEffect(() => {
    dispatch(getAllLocations());
  }, [dispatch]);

  useEffect(() => {
    if (searchText.length > 0) {
      setResults(
        location.locationList.filter(
          x =>
            x.locationName.toLowerCase().includes(searchText.toLowerCase()) ||
            x.contactPerson.toLowerCase().includes(searchText.toLowerCase()) ||
            x.contactEmail.toLowerCase().includes(searchText.toLowerCase()) ||
            x.contactPhone.toLowerCase().includes(searchText.toLowerCase())
        )
      );
    } else {
      setResults(location.locationList);
    }
  }, [searchText, setResults, location.locationList]);

  const onPageChangeHandler = currentPage => {};

  const onAddNewHandler = () => {
    history.push('/master/locations/location');
  };

  const onEditHandler = id => {
    history.push(`/master/locations/location/${id}`);
  };

  const breadCrumbPaths = [
    { id: 1, title: 'Home', path: '/' },
    { id: 2, title: 'Location Listing', path: '/master/locations', isCurrent: true }
  ];

  const handleInput = e => {
    setSearchText(e.target.value);
  };

  const onDeleteHandler = id => {
    dispatch(
      setOnConfirmationModal({
        data: {
          showConfirmationModal: true,
          confirmationId: id
        }
      })
    );
  };

  const onDeleteConfirmation = () => {
    if (location.confirmationId) {
      dispatch(deleteLocation(location.confirmationId));
    }
  };

  const onDeleteCancel = () => {
    dispatch(
      setOnConfirmationModal({
        data: {
          showConfirmationModal: false,
          confirmationId: ''
        }
      })
    );
  };

  return (
    <React.Fragment>
      <CustomConfirmation
        show={location.showConfirmationModal}
        onDeleteClick={onDeleteConfirmation}
        onCloseClick={onDeleteCancel}
        message="Are you sure you want to delete this record?"
        header="Deleting record"
      />
      <div className="page-content">
        {location.showMessage && <Notification notificationType={notificationType} message={location.message} />}
        <Container fluid>
          <Breadcrumbs title="Location Listing " paths={breadCrumbPaths} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Row className="mb-2 buttonrow">
                    <Col sm="4">
                      <SearchBar onChange={handleInput} placeholder="Search" value={searchText} />
                    </Col>
                    <Col sm="8">
                      <div className="text-sm-end">
                        {showSaveOption && (
                          <Button type="button" className="btn btn-primary btn-block  app-add-button" onClick={onAddNewHandler}>
                            ADD LOCATION
                          </Button>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row className="tablerow">
                    <Col xl="12">
                      <div>
                        {location.isLoading && <LoadingSpinner />}
                        <Pagination data={results} pageSize={pageSize} onPageChange={onPageChangeHandler} startingPage={1}>
                          <Table editHandler={onEditHandler} deleteHandler={onDeleteHandler} showDelete={showDeleteOption} />
                        </Pagination>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Location;
